module.exports = __webpack_public_path__ + "static/img/s6.6a8311b3.png";